import { render, staticRenderFns } from "./ParamEditor.vue?vue&type=template&id=18e780d1&"
import script from "./ParamEditor.vue?vue&type=script&lang=ts&"
export * from "./ParamEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports